<div [dialogRef]="dialog" (appClickOutside)="close(false)" class="sage-invoice-reminder-modal">
  <kendo-dialog-titlebar (close)="close(false)">
    <div class="modal-title">
      <span>Send Overdue Email(s)</span>
    </div>
  </kendo-dialog-titlebar>

  <div class="model-body" [formGroup]="form">
    <div class="stepper-container">
      <kendo-stepper [steps]="steps" [stepType]="stepType" [(currentStep)]="current" [style.width.px]="570">
      </kendo-stepper>
    </div>

    <div class="step-content-container">
      <!-- Step 1: Contact Emails -->
      <div *ngIf="current === 0" class="step-content animate-fade-in">
        <h3>Verify Contact Emails</h3>
        <p>Please confirm or update the email addresses for the selected invoices. Additional emails will be added to cc.</p>
        <div formArrayName="invoices" class="invoice-list">
          <div *ngFor="let invoice of invoiceFormArray.controls; let i = index" [formGroupName]="i">
            <kendo-gridlayout [rows]="['auto']" [cols]="['100%']" style="margin-bottom: 0;">
              <kendo-gridlayout-item>
                <kendo-formfield>
                  <kendo-label class="asterisk" [for]="emailInput"
                    text="Invoice #: {{ invoice.get('invoiceNumber')?.value + ' ' + invoices[i].customerName}}"></kendo-label>
                  <kendo-multiselect #emailInput formControlName="customerEmail" [allowCustom]="true"
                    [valueNormalizer]="valueNormalizer" placeholder="Type email and press enter" fillMode="outline">
                    <ng-template kendoDropDownListNoDataTemplate>
                    </ng-template>
                  </kendo-multiselect>
                  <kendo-formerror>
                    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                    <span *ngIf="invoice.get('customerEmail')?.errors?.required">Email is required.</span>
                  </kendo-formerror>
                </kendo-formfield>
              </kendo-gridlayout-item>
            </kendo-gridlayout>
          </div>
        </div>
      </div>

      <!-- Step 2: Email Templates -->
      <div *ngIf="current === 1" class="step-content animate-fade-in">
        <h3>Select Email Template</h3>
        <p>Choose a template to pre-fill the email subject and body.</p>

        <kendo-gridlayout [rows]="['auto']" [cols]="['100%']" style="margin-bottom: 0;">
          <kendo-gridlayout-item>
            <kendo-formfield>
              <kendo-label class="asterisk" [for]="templateDrop" text="Template"></kendo-label>
              <kendo-dropdownlist #templateDrop [data]="emailTemplates" textField="title" valueField="title"
                formControlName="template" [defaultItem]="{ title: null , displayValue: 'Select Template...'}"
                placeholder="Select template" (valueChange)="onTemplateChange($event)" fillMode="outline"
                [filterable]="false" [popupSettings]="{appendTo: 'component', animate: false, width: 250 }">
                <ng-template kendoDropDownListValueTemplate let-dataItem>
                  <span *ngIf="!dataItem?.title" class="placeholder"> {{ dataItem?.title || dataItem?.displayValue }}
                  </span>
                  <span *ngIf="dataItem?.title" class="not-placeholder"> {{ dataItem?.title || dataItem?.displayValue }}
                  </span>
                </ng-template>
                <ng-template kendoDropDownListItemTemplate let-dataItem>
                  <span *ngIf="!dataItem?.title" class="placeholder"> {{ dataItem?.title || dataItem?.displayValue }}
                  </span>
                  <span *ngIf="dataItem?.title" class="not-placeholder"> {{ dataItem?.title || dataItem?.displayValue }}
                  </span>
                </ng-template>
              </kendo-dropdownlist>
              <kendo-formerror>
                <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                <span *ngIf="form.get('template')?.errors?.required">Template is required.</span>
              </kendo-formerror>
            </kendo-formfield>
          </kendo-gridlayout-item>
        </kendo-gridlayout>

        <kendo-gridlayout [rows]="['auto']" [cols]="['100%']" style="margin-bottom: 0;">
          <kendo-gridlayout-item>
            <kendo-formfield>
              <kendo-label class="asterisk" [for]="fromDrop" text="From"></kendo-label>
              <kendo-dropdownlist #fromDrop [data]="fromEmailOptions" formControlName="from" [valuePrimitive]="true"
                fillMode="outline" [popupSettings]="{appendTo: 'component', animate: false}">
              </kendo-dropdownlist>
              <kendo-formerror>
                <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                <span *ngIf="form.get('from')?.errors?.required">From is required.</span>
              </kendo-formerror>
            </kendo-formfield>
          </kendo-gridlayout-item>
        </kendo-gridlayout>

        <kendo-gridlayout [rows]="['auto']" [cols]="['100%']" style="margin-bottom: 0;">
          <kendo-gridlayout-item>
            <kendo-formfield>
              <kendo-label class="asterisk" [for]="subjectText" text="Subject"></kendo-label>
              <kendo-textbox #subjectText formControlName="subject" placeholder="Enter email subject" fillMode="outline"
                [clearButton]="true"></kendo-textbox>
              <kendo-formerror>
                <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                <span *ngIf="form.get('subject')?.errors?.required">Subject is required.</span>
              </kendo-formerror>
            </kendo-formfield>
          </kendo-gridlayout-item>
        </kendo-gridlayout>

        <kendo-gridlayout [rows]="['auto']" [cols]="['100%']" style="margin-bottom: 0;">
          <kendo-gridlayout-item>
            <kendo-formfield>
              <kendo-label class="asterisk" [for]="bodyEditor" text="Email Body"></kendo-label>
              <kendo-editor #bodyEditor formControlName="body" style="height: 500px;">
                <kendo-toolbar>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
                  <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
                  <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                </kendo-toolbar>
              </kendo-editor>
            </kendo-formfield>
            <div class="k-form-error"
              *ngIf="(form.get('body')?.touched || form.get('body')?.dirty) && form.get('body')?.errors?.required">
              <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
              <span>Body is required.</span>
            </div>
          </kendo-gridlayout-item>
        </kendo-gridlayout>
      </div>
    </div>
  </div>

  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="close(false)">Cancel</button>
    <button kendoButton (click)="prev()" class="ml-16" [disabled]="current === 0" *ngIf="current > 0">Previous</button>
    <button kendoButton themeColor="primary" class="ml-16" (click)="next()" *ngIf="current < steps.length - 1"
      [disabled]="current === 0 && !isStep1Valid">
      Next
    </button>
    <button kendoButton themeColor="primary" class="ml-16" (click)="submit()" *ngIf="current === steps.length - 1"
      [disabled]="!isStep2Valid">
      Send Reminders
    </button>
  </kendo-dialog-actions>
</div>
